// Utility helpers to extract and normalize file paths from pipeline messages

export function extractFilePathsFromText(text) {
  if (!text || typeof text !== 'string') return [];
  if (!/Action Response for 'saveTextToFile':/i.test(text)) return [];
  const results = [];

  // Observation: File saved successfully to: <path>
  const regexObs = /Observation:\s*File\s+saved\s+successfully\s+to:\s*([^\n\r`]+)/gi;
  let mo;
  while ((mo = regexObs.exec(text)) !== null) {
    if (mo[1]) results.push(mo[1].trim());
  }
  return results;
}

export function normalizeToHomeRelative(p) {
  if (!p) return '';
  let s = String(p).trim();
  if (!s) return '';
  if (s.endsWith('/n')) s = s.slice(0, -2); // strip common stray '/n' suffix from tool outputs
  s = s.replace(/\\/g, '/');
  if (s.startsWith('./')) s = s.substring(2);
  const marker = '/Home/';
  const idx = s.indexOf(marker);
  if (idx >= 0) {
    return s.substring(idx + marker.length);
  }
  if (s.startsWith('Home/')) return s.substring('Home/'.length);
  return s;
}
